module.exports = __webpack_public_path__ + "img/demo_food-400x300.ce164559.png";